import React from "react"
import { AppIconChipToggle } from "@components"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { boolean, object } from "yup"

export default function ReportLaunchRepricingSwitch() {
	const { launchRepricing, setLaunchRepricingInfo } = useReportFormInfo(
		reportFormData.peek()?.launchRepricing,
		"launchRepricing",
		object({ launchRepricing: boolean() })
	)

	return <AppIconChipToggle
		aria-label="Repricing"
		value={!!launchRepricing}
		options={[
			{ value: false, label: 'No repricing', icon: 'ban' },
			{ value: true, label: 'Launch repricing', icon: 'wand-magic-sparkles' },
		]}
		onChange={value => setLaunchRepricingInfo(value)}
	/>
}
